/**
 * Pure validation for Entra connect form (testable).
 */

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * @param {{ tenant_id?: string, client_id?: string, client_secret?: string }} fields
 */
export function validateEntraConnectFields(fields) {
  const tenant_id = String(fields?.tenant_id || "").trim();
  const client_id = String(fields?.client_id || "").trim();
  const client_secret = String(fields?.client_secret || "").trim();

  if (!tenant_id) return { ok: false, error: "Directory (tenant) ID is required." };
  if (!UUID_RE.test(tenant_id)) return { ok: false, error: "Directory (tenant) ID must be a valid GUID." };
  if (!client_id) return { ok: false, error: "Application (client) ID is required." };
  if (!UUID_RE.test(client_id)) return { ok: false, error: "Application (client) ID must be a valid GUID." };
  if (!client_secret) return { ok: false, error: "Client secret is required." };
  if (client_secret.length < 8) return { ok: false, error: "Client secret looks too short." };

  return { ok: true, tenant_id, client_id, client_secret };
}

/**
 * @param {unknown} body
 */
export function mapEntraConnectApiError(body) {
  if (!body || typeof body !== "object") return "Connection failed";
  const b = /** @type {Record<string, unknown>} */ (body);
  if (b.message) return String(b.message);
  if (b.error === "INVALID_CREDENTIALS") return "Invalid client credentials — check tenant ID, client ID, and secret.";
  if (b.error === "INSUFFICIENT_SCOPE") return "Insufficient Graph permissions — grant admin consent for required application permissions.";
  if (b.error === "TENANT_NOT_FOUND") return "Tenant not found.";
  return String(b.error || "Connection failed");
}
